import { useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useStateContext } from "../../context/StateContext";

import Footer from "../Footer/Footer";
import Options from "../Options/Options";
import CardHolder from "../Cardholder/CardHolder";
import getiNatData from "../../getiNatData"
import classes from './HomePage.module.css'

const HomePage = ({ iconicTaxa, month, setMonth, location, setLocation, locations }) => {
    const {setAllSpeciesData } = useStateContext();

    const [sortMethod, setSortMethod] = useState('common');

    const locParams = useParams();
    const navigate = useNavigate();
    
    useEffect(() => {
        const locExists = locations.filter(l => l.slug === locParams.loc).length > 0
        if (!locExists) {
          navigate("../");
        } else {
            console.log('Setting new location')
        const newLoc = locations.filter(l => l.slug === locParams.loc)
        console.log({newLoc: newLoc.length})
        setLocation(newLoc[0])
        document.title = newLoc[0]?.title
        
        getiNatData(setAllSpeciesData, newLoc[0].bbox, true, newLoc[0].project_id)
        getiNatData(setAllSpeciesData, newLoc[0].bbox, false, newLoc[0].project_id)       
        }
        return
        // locations and the setters are stable; re-running this fetch effect on
        // anything but a route change would double-fire the iNat requests
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [locParams]);

    
  
    const speciesList = iconicTaxa.map(x => {
        return (
            <CardHolder
                key={x.taxa}
                title={x.title}
                taxonName={x.taxa}
                sortMethod={sortMethod}
                month={month}/>
        )
    })

    return (
        <>
            <h1 className={classes.title}>{location.title + " Field Guide"}</h1>
            <Options
                month={month}
                setMonth={setMonth}
                sortMethod={sortMethod}
                setSortMethod={setSortMethod}
                location={location}
                setLocation={setLocation} />
            {speciesList}
            <Footer />
        </>
    )
}

export default HomePage